import { BroadcastChannel } from 'broadcast-channel';
import { themeChannelName } from '../constants/ChannelConstants';
import { darkMediaQuery, themeStorageKey, } from '../constants/ThemeConstants';
import { isBrowserIE } from './BrowserUtil';
let themeChannelOut = null;
function createThemeChannel() {
    return new BroadcastChannel(themeChannelName);
}
function getDarkMediaQueryList() {
    var _a, _b;
    return (_b = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, darkMediaQuery)) !== null && _b !== void 0 ? _b : null;
}
function isDarkWindowModeActive() {
    var _a, _b;
    return (_b = (!isBrowserIE() && ((_a = getDarkMediaQueryList()) === null || _a === void 0 ? void 0 : _a.matches))) !== null && _b !== void 0 ? _b : false;
}
function getAutoThemeValue() {
    return isDarkWindowModeActive() ? 'dark' : 'light';
}
export function getApolloThemeFromTheme(theme) {
    if (theme === 'autoTheme') {
        return getAutoThemeValue();
    }
    return theme === 'dark' ? 'dark' : 'light';
}
export function getCachedTheme() {
    return localStorage.getItem(themeStorageKey);
}
export function setTheme(theme) {
    if (!themeChannelOut) {
        themeChannelOut = createThemeChannel();
    }
    localStorage.setItem(themeStorageKey, theme);
    themeChannelOut.postMessage(theme);
}
/**
 * @returns The disposer
 */
export function handleThemeChange(callback) {
    const channel = createThemeChannel();
    channel.onmessage = theme => {
        callback(theme);
    };
    return () => {
        channel.close();
    };
}
